<template>
  <div class="col-12 visual_mode_show">
    <div id="app-warehouse" class="warehouse">
      <div class="app-wrapper">
        <div class="row headline">
          <div class="col-12">
            <h3>{{ $t("Warehouse.title") }}</h3>
          </div>
        </div>
        <template
          v-if="
            Object.values(list)[0] &&
            typeof Object.values(list)[0].places === 'object'
          "
        >
          <div
            class="row warehouse-entry"
            v-for="(placeList, setId) in list"
            v-bind:key="setId"
          >
            <div class="col-12">
              <ul class="place-list">
                <template v-if="placeList.places.length > 0">
                  <li
                    v-for="(place, numericKey) in placeList.places"
                    v-bind:key="setId + '_' + numericKey"
                  >
                    {{ place.master_set }}<br />{{ place.description }}
                  </li>
                </template>
                <template v-else>
                  <li>
                    {{ $t("Warehouse.empty") }}
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="col-12 text-center warehouse-empty">
            <p>{{ $t("Warehouse.empty") }}</p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Warehouse from "@/assets/DAO/Warehouse";
import Config from "@/vuex/Config";

export default {
  name: "Warehouse",
  data() {
    return {
      imageHost: process.env.VUE_APP_IMAGE_HOST,
      appUrl: Config.getters.getAppUrl,
      list: {},
    };
  },
  mounted() {
    if (this.$parent.currentNavigation === "warehouse") {
      this.getPlaces();
    }
  },
  methods: {
    getPlaces: function () {
      let setIds = this.$parent.getSetIds();

      if (setIds.length > 0) {
        for (let i in setIds) {
          Warehouse.getPlaces(setIds[i]).then((result) => {
            this.list[setIds[i]] = result;
            this.$forceUpdate();
          });
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  h3 {
    font-size: 1.7rem;
    text-align: center;
    margin-top: 2.7rem;
    padding: 1rem;
    border-bottom: 0.1rem solid $borderColor;
  }
}

#app-warehouse {
  background-color: $white;

  .app-wrapper {
    padding: 1.5rem;
  }

  .warehouse-empty {
    p {
      margin-top: 2rem;
      line-height: 10rem;
    }
  }

  .warehouse-entry {
    padding: 2rem 0;

    .place-list {
      list-style-type: none;
      padding: 0;

      li {
        padding: 0.5rem 1.5rem;

        &:nth-child(even) {
          background-color: $lightGreyBg;
        }
      }
    }
  }
}
</style>
